import { z } from 'zod';

export const Division = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  enabled: z.boolean().default(false),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
});
export type DivisionType = z.infer<typeof Division>;
